import { useEffect, useRef } from 'react'
import { Button, ButtonProps } from '../../../components'
import { useCogfy } from '../../../hooks'
import { useQuery } from '@tanstack/react-query'
import { popupCenter } from '../../../helpers/popup-center'
import { PlusIcon } from 'lucide-react'

type AddAzureAdButtonProps = {
  onSuccess?: () => void
}

export function AddAzureAdButton (props: AddAzureAdButtonProps & ButtonProps) {
  const { onSuccess } = props

  const cogfy = useCogfy()
  const windowRef = useRef<Window | null>(null)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  const data = {
    provider: 'azureAd' as const
  }
  const getAzureAdAuthUrl = useQuery({
    queryKey: ['getAzureAdAuthUrl', data],
    queryFn: ({ signal }) => cogfy.getAzureAdAuthUrl(data, { signal })
  })

  const checkPopupClosed = () => {
    if (windowRef.current && windowRef.current.closed) {
      clearInterval(intervalRef.current!)
      intervalRef.current = null
      onSuccess?.()
    }
  }

  const openPopup = () => {
    if (getAzureAdAuthUrl.data?.authUrl) {
      windowRef.current = popupCenter(getAzureAdAuthUrl.data.authUrl)
      intervalRef.current = setInterval(checkPopupClosed, 200)
    }
  }

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  })

  return (
    <Button
      color={props.color}
      size={props.size || 'sm'}
      disabled={getAzureAdAuthUrl.isLoading}
      onClick={openPopup}
      className={props.className}
    >
      <PlusIcon size={16} />
      {props.children}
    </Button>
  )
}
